import { Archive } from "lucide-react";

const STATI = {
  stored: ["Conservata", "bg-emerald-100 text-emerald-800"],
  sent: ["In conservazione", "bg-sky-100 text-sky-800"],
  to_be_stored: ["Da conservare", "bg-slate-100 text-slate-600"],
  error: ["Errore conservazione", "bg-rose-100 text-rose-800"],
};

export const ConservazioneBadge = ({ c, testid }) => {
  if (!c?.stato) return null;
  const [l, cls] = STATI[c.stato] || [c.stato, "bg-slate-100 text-slate-600"];
  return (
    <span data-testid={testid} title={c.errore || (c.at ? `Conservazione a norma dal ${new Date(c.at).toLocaleDateString("it-IT")}` : l)}
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded px-1.5 py-0.5 text-[10px] font-semibold ${cls}`}>
      <Archive className="h-3 w-3" />{l}
    </span>
  );
};
